// YERİ: src/app/domains/site/sections/cta.section.ts
// Aksiyon çağrısı bandı (accent arka plan).

import { Component, computed, input } from '@angular/core';
import { SiteConfig, cfg } from './section.model';

@Component({
  selector: 'sec-cta',
  standalone: true,
  template: `
    <section id="cta" class="py-20" style="background-color:var(--site-accent)">
      <div class="mx-auto max-w-4xl px-6 text-center lg:px-8">
        <h2 class="font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-white sm:text-4xl">{{ title() }}</h2>
        @if (subtext()) { <p class="mx-auto mt-4 max-w-2xl text-lg text-white/85">{{ subtext() }}</p> }
        <a [href]="ctaUrl()" [target]="newTab() ? '_blank' : '_self'" [attr.rel]="newTab() ? 'noopener' : null"
           class="ws-btn mt-9 inline-flex items-center justify-center rounded-lg bg-white px-8 py-3.5 text-sm font-semibold shadow-lg transition hover:opacity-90"
           style="color:var(--site-primary)">
          {{ ctaText() }}
        </a>
      </div>
    </section>
  `,
})
export class CtaSection {
  config = input<SiteConfig>({});
  protected title = computed(() => cfg(this.config(), 'title', 'Hukuki Sorununuz İçin Hemen Görüşelim'));
  protected subtext = computed(() => cfg(this.config(), 'subtext', 'İlk değerlendirme görüşmesi ücretsizdir. Uzman ekibimiz size en kısa sürede dönüş yapsın.'));
  protected ctaText = computed(() => cfg(this.config(), 'ctaText', 'Randevu Al'));
  protected ctaUrl = computed(() => cfg(this.config(), 'ctaUrl', '#contact'));
  protected newTab = computed(() => ['true', 'evet', '1'].includes(String(cfg(this.config(), 'ctaNewTab', '')).toLowerCase()));
}
